const AlignedTextCenter = () => (
  <>
    <path
      fill="currentColor"
      d="M16.5 17.27q.212 0 .356-.145a.49.49 0 0 0 .144-.357.48.48 0 0 0-.144-.355.48.48 0 0 0-.356-.144h-9a.48.48 0 0 0-.356.144.48.48 0 0 0-.144.357q0 .212.144.356a.49.49 0 0 0 .356.143zm-2-4.77q.213 0 .356-.144a.49.49 0 0 0 .144-.357.48.48 0 0 0-.144-.356.48.48 0 0 0-.356-.143h-5a.48.48 0 0 0-.356.144.49.49 0 0 0-.144.357q0 .213.144.356a.49.49 0 0 0 .356.143zm4-4.77q.212 0 .356-.143A.48.48 0 0 0 19 7.23a.48.48 0 0 0-.144-.356.49.49 0 0 0-.356-.143h-13a.48.48 0 0 0-.356.144A.49.49 0 0 0 5 7.23q0 .213.144.356a.49.49 0 0 0 .356.144z"
    />
  </>
)
export default AlignedTextCenter
